import { render, staticRenderFns } from "./FirstPurchase.vue?vue&type=template&id=8fbefa38&scoped=true&"
import script from "./FirstPurchase.vue?vue&type=script&lang=js&"
export * from "./FirstPurchase.vue?vue&type=script&lang=js&"
import style0 from "./FirstPurchase.vue?vue&type=style&index=0&id=8fbefa38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbefa38",
  null
  
)

export default component.exports